import styled from 'styled-components';
import AuctionCalendar from './calander/Calander';
import { useEffect, useState } from 'react';
import LoanInfoService from '../../../service/LoanInfo';

const MainCalendar = () => {
  const [court, setCourt] = useState<string>('');
  const [tabCategory, setTabCategory] = useState<string>('a');
  const [calendarData, setCalendarData] = useState([]);
  const [curCalendarData, setCurCalendarData] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [selectedDate, setSelectedDate] = useState(
    new Date()
      .toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(/\. /g, '-')
      .replace('.', ''),
  );

  const getData = async () => {
    try {
      const res = await LoanInfoService.calendar(
        court,
        '',
        selectedDate,
        tabCategory,
        '',
        20,
        0,
      );
      setTotal(res.data.totalNumber);
      setCalendarData(res.data.calendar);
      setCurCalendarData(res.data.cur_calendar);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getData();
  }, [tabCategory, selectedDate]);

  return (
    <AuctionCalenderBox>
      <AuctionCalendarInner>
        <AuctionTabBox>
          <AuctionTab
            active={tabCategory === 'a'}
            onClick={() => setTabCategory('a')}
          >
            경매일정
          </AuctionTab>
          <AuctionTab
            active={tabCategory === 'n'}
            onClick={() => setTabCategory('n')}
          >
            경매신건
          </AuctionTab>
          <AuctionTab
            active={tabCategory === 's'}
            onClick={() => setTabCategory('s')}
          >
            입찰결과
          </AuctionTab>
        </AuctionTabBox>
        <AuctionCalendar
          page="main"
          court={court}
          setCourt={setCourt}
          calendarData={calendarData}
          curCalendarData={curCalendarData}
          tabCategory={tabCategory}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
      </AuctionCalendarInner>
    </AuctionCalenderBox>
  );
};

export default MainCalendar;

interface IRegionTab {
  active: boolean;
}

const AuctionCalenderBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
`;
const AuctionCalendarInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const AuctionTabBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const AuctionTab = styled.div<IRegionTab>`
  width: 80px;
  // height: 46px;
  display: flex;
  gap: 8px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  color: ${({ active }) => (active ? '#fff' : '#989ba2')};
  // border: 1px solid rgba(112, 115, 124, 0.16);
  border-bottom: none;
  border-radius: 9999px;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? '#222' : 'rgba(112, 115, 124, 0.08)'};
`;
